import React from "react";
import { NavItem, Badge } from "reactstrap";
import { NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import classnames from "classnames";
import moment from "moment";

import ApplicationMenu from "../../../../components/common/ApplicationMenu";
import IntlMessages from "../../../../helpers/IntlMessages";

const StockReturnApplicationMenu = ({ data = [], filter, onFilterChange }) => {
  // Tính toán counts
  const getFilteredCount = (filterFunc) => {
    return data.filter(filterFunc).length;
  };

  // Filter by status
  const countPending = getFilteredCount((item) => item.status === "pending");
  const countCompleted = getFilteredCount(
    (item) => item.status === "completed",
  );

  // Filter by month
  const getMonthCount = (monthsAgo) => {
    const startOfMonth = moment()
      .subtract(monthsAgo, "months")
      .startOf("month");
    const endOfMonth = moment().subtract(monthsAgo, "months").endOf("month");
    return getFilteredCount((item) => {
      const itemDate = moment(item.createdAt);
      return itemDate.isBetween(startOfMonth, endOfMonth, null, "[]");
    });
  };

  const countThisMonth = getMonthCount(0);
  const countLastMonth = getMonthCount(1);

  // Tổng giá trị hoàn hàng
  const getTotalValue = () => {
    return data.reduce((sum, item) => sum + (item.total_value || 0), 0);
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("vi-VN").format(value || 0);
  };

  return (
    <ApplicationMenu>
      <PerfectScrollbar
        options={{ suppressScrollX: true, wheelPropagation: false }}
      >
        <div className="p-4">
          <p className="text-muted text-small">
            <IntlMessages id="menu.stock.status" />
          </p>
          <ul className="list-unstyled mb-4">
            <NavItem
              className={classnames({
                active: !filter || filter.type === "all",
              })}
            >
              <NavLink
                to="#"
                onClick={() => onFilterChange({ type: "all" })}
                location={{}}
              >
                <span>
                  <IntlMessages id="general.all" />
                </span>
                <span className="float-right">{data.length}</span>
              </NavLink>
            </NavItem>
            <NavItem
              className={classnames({
                active:
                  filter &&
                  filter.type === "status" &&
                  filter.value === "pending",
              })}
            >
              <NavLink
                to="#"
                onClick={() =>
                  onFilterChange({ type: "status", value: "pending" })
                }
                location={{}}
              >
                <i className="simple-icon-clock mr-2" />
                <span>
                  <IntlMessages id="status.processing" />
                </span>
                <span className="float-right">{countPending}</span>
              </NavLink>
            </NavItem>
            <NavItem
              className={classnames({
                active:
                  filter &&
                  filter.type === "status" &&
                  filter.value === "completed",
              })}
            >
              <NavLink
                to="#"
                onClick={() =>
                  onFilterChange({ type: "status", value: "completed" })
                }
                location={{}}
              >
                <i className="simple-icon-check mr-2" />
                <span>
                  <IntlMessages id="status.completed" />
                </span>
                <span className="float-right">{countCompleted}</span>
              </NavLink>
            </NavItem>
          </ul>

          <p className="text-muted text-small">
            <IntlMessages id="menu.stock.time" />
          </p>
          <ul className="list-unstyled mb-4">
            <NavItem
              className={classnames({
                active: filter && filter.type === "month" && filter.value === 0,
              })}
            >
              <NavLink
                to="#"
                onClick={() => onFilterChange({ type: "month", value: 0 })}
                location={{}}
              >
                <span>
                  <IntlMessages id="general.this-month" />
                </span>
                <span className="float-right">{countThisMonth}</span>
              </NavLink>
            </NavItem>
            <NavItem
              className={classnames({
                active: filter && filter.type === "month" && filter.value === 1,
              })}
            >
              <NavLink
                to="#"
                onClick={() => onFilterChange({ type: "month", value: 1 })}
                location={{}}
              >
                <span>
                  <IntlMessages id="general.last-month" />
                </span>
                <span className="float-right">{countLastMonth}</span>
              </NavLink>
            </NavItem>
          </ul>

          <p className="text-muted text-small">
            <IntlMessages id="menu.stock.statistics" />
          </p>
          <div className="mb-4">
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">
                <IntlMessages id="menu.stock.total-tickets" />:
              </span>
              <strong>{data.length}</strong>
            </div>
            <div className="d-flex justify-content-between">
              <span className="text-muted">
                <IntlMessages id="menu.stock.total-value" />:
              </span>
              <strong className="text-primary">
                {formatCurrency(getTotalValue())} đ
              </strong>
            </div>
          </div>
        </div>
      </PerfectScrollbar>
    </ApplicationMenu>
  );
};

export default StockReturnApplicationMenu;
